/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Not_ConfiguredInputs */

const th_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้เปิดใช้งานวิดีโอสดสำหรับระบบนี้`)
};

const en_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live video is not switched on for this deployment yet.`)
};

const ja_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境ではまだライブ映像が有効になっていません。`)
};

const zh_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此安装尚未开启实时视频。`)
};

const es_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El vídeo en directo aún no está activado en esta instalación.`)
};

const pt_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O vídeo ao vivo ainda não está ligado nesta instalação.`)
};

const id_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video langsung belum dinyalakan untuk pemasangan ini.`)
};

const fr_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vidéo en direct n’est pas encore activée sur ce déploiement.`)
};

const tl_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pa nakabukas ang live na video para sa instalasyong ito.`)
};

const vi_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản cài này chưa bật video trực tiếp.`)
};

const ko_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 설치본에는 실시간 영상이 아직 켜져 있지 않습니다.`)
};

const de_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Video ist für diese Installation noch nicht eingeschaltet.`)
};

const ru_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прямой эфир для этой установки ещё не включён.`)
};

const tr_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kurulumda canlı görüntü henüz açılmadı.`)
};

const it_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il video in diretta non è ancora attivo per questa installazione.`)
};

const pl_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obraz na żywo nie jest jeszcze włączony w tej instalacji.`)
};

const uk_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прямий ефір для цієї інсталяції ще не ввімкнено.`)
};

const hi_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस इंस्टॉलेशन के लिए लाइव वीडियो अभी चालू नहीं है।`)
};

const ar_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يُفعَّل البث المباشر لهذا التنصيب بعد.`)
};

const ms_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video langsung belum dihidupkan untuk pemasangan ini.`)
};

const bn_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ইনস্টলেশনে সরাসরি ভিডিও এখনও চালু হয়নি।`)
};

const zh_tw2_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個安裝尚未開啟即時影片。`)
};

const zh_hk2_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個安裝尚未開啟即時短片。`)
};

const ur_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس تنصیب کے لیے براہ راست ویڈیو ابھی چالو نہیں۔`)
};

const fa_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصویر زنده برای این نصب هنوز روشن نشده است.`)
};

const sw_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video ya moja kwa moja haijawashwa kwa usakinishaji huu bado.`)
};

const nl_video_not_configured = /** @type {(inputs: Video_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live video staat voor deze installatie nog niet aan.`)
};

/**
* | output |
* | --- |
* | "Live video is not switched on for this deployment yet." |
*
* @param {Video_Not_ConfiguredInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_not_configured = /** @type {((inputs?: Video_Not_ConfiguredInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Not_ConfiguredInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_not_configured(inputs)
	if (locale === "ja") return ja_video_not_configured(inputs)
	if (locale === "zh") return zh_video_not_configured(inputs)
	if (locale === "es") return es_video_not_configured(inputs)
	if (locale === "pt") return pt_video_not_configured(inputs)
	if (locale === "id") return id_video_not_configured(inputs)
	if (locale === "fr") return fr_video_not_configured(inputs)
	if (locale === "tl") return tl_video_not_configured(inputs)
	if (locale === "vi") return vi_video_not_configured(inputs)
	if (locale === "ko") return ko_video_not_configured(inputs)
	if (locale === "de") return de_video_not_configured(inputs)
	if (locale === "ru") return ru_video_not_configured(inputs)
	if (locale === "tr") return tr_video_not_configured(inputs)
	if (locale === "it") return it_video_not_configured(inputs)
	if (locale === "pl") return pl_video_not_configured(inputs)
	if (locale === "uk") return uk_video_not_configured(inputs)
	if (locale === "hi") return hi_video_not_configured(inputs)
	if (locale === "ar") return ar_video_not_configured(inputs)
	if (locale === "ms") return ms_video_not_configured(inputs)
	if (locale === "bn") return bn_video_not_configured(inputs)
	if (locale === "zh-TW") return zh_tw2_video_not_configured(inputs)
	if (locale === "zh-HK") return zh_hk2_video_not_configured(inputs)
	if (locale === "ur") return ur_video_not_configured(inputs)
	if (locale === "fa") return fa_video_not_configured(inputs)
	if (locale === "sw") return sw_video_not_configured(inputs)
	if (locale === "nl") return nl_video_not_configured(inputs)
	return en_video_not_configured(inputs)
});